import { Container, Table } from "reactstrap";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";
import { useParams } from "react-router-dom";
import { productListTableData } from "../../../data/organization/OrganizationList";
import InvoiceThreeHeader from "./ViewHeaderSection";
import ViewSubscriptionSection from "./ViewSubscriptionSection";
import ViewGeneralSection from "./ViewGeneralSection";
import ProjectDetails from "./ViewDetails";
import ViewAppsSection from "./ViewAppsSection";
import { useTranslation } from "react-i18next";

const ViewContainer = () => {
  const { id } = useParams();
  const {t} =useTranslation()
  const orgData = productListTableData.find(
    (org: any) => org.id.toString() === id
  );
  console.log(orgData, "orgData");

  return (
    <>
  
      <Breadcrumbs
        mainTitle= {t("ViewOrganization")}
        parents={[
          { label: t("Master Data") },
          {
            label: t("Organizations"),
            link: `${process.env.PUBLIC_URL}/masterdata/organization`,
          },
        ]}
      />
  
      <Container className="invoice-5 view-organization-container">
        <div>
          <Table borderless>
            <tbody>
              <tr>
                <InvoiceThreeHeader orgData={orgData} />
              </tr>
              <tr>
                <ProjectDetails item={orgData} />
              </tr>
              <tr>
                <ViewSubscriptionSection orgData={orgData} />
              </tr>

              <tr>
                <ViewGeneralSection orgData={orgData} />
              </tr>
              <tr>
                <ViewAppsSection orgData={orgData} />
              </tr>
            </tbody>
          </Table>
        </div>
      </Container>
    </>
  );
};

export default ViewContainer;
